import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Lightbox.css';

const Lightbox = ({ images, currentIndex, onClose, onPrev, onNext }) => {
    if (!images || images.length === 0) return null;

    return (
        <AnimatePresence>
            <motion.div
                className="lightbox-overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={onClose}
            >
                <div className="lightbox-content" onClick={e => e.stopPropagation()}>
                    <button className="lightbox-close" onClick={onClose}>
                        <FaTimes />
                    </button>

                    {images.length > 1 && (
                        <>
                            <button className="lightbox-nav prev" onClick={onPrev}>
                                <FaChevronLeft />
                            </button>
                            <button className="lightbox-nav next" onClick={onNext}>
                                <FaChevronRight />
                            </button>
                        </>
                    )}

                    <motion.div
                        className="lightbox-image-container"
                        key={currentIndex}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ type: "spring", damping: 25, stiffness: 200 }}
                    >
                        <img src={images[currentIndex]} alt={`Full view ${currentIndex}`} />
                    </motion.div>

                    <div className="lightbox-counter">
                        {currentIndex + 1} / {images.length}
                    </div>
                </div>
            </motion.div>
        </AnimatePresence>
    );
};

export default Lightbox;
